import React, { useEffect, useState } from "react";
import ReactSelect from "react-select";
import BXPDetails from "./BXPDetails";
import WorkSamples from "./WorkSamples";
import PricingTerms from "./PricingTerms";
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import { formatNumberWithCommas } from "../../../Common/AllDateTimeReleventFormate";
import CustomReactQuillDescription from "../../../Common/CustomeLabel/ReactQuill/CustomReactQuillDescription";
import { decodeHtml } from "../../../../assests/extention/commonfunction";

const options = [
  { value: "1", label: "Category 1" },
  { value: "2", label: "Category 2" },
  { value: "3", label: "Category 3" },
  { value: "4", label: "Category 4" },
];

const AddBXP = ({ formData, setFormData, nextPage, previousPage }) => {
  const [activeTab, setActiveTab] = useState("BXPDetails");
  const [modalOpen, setModalOpen] = useState(false);
  const [bxpDataList, setbxpDataList] = useState(formData?.bxp || []);
  const [bxpData, setbxpData] = useState(formData?.bxp || []);

  const toggleTab = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const openModal = () => {
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  const modalStyle = {
    right: modalOpen ? "0" : "-50%",
  };

  const deleteBxp = (index) => {
    setbxpData((prevData) => prevData.filter((_, i) => i !== index));
  };

  const updateBxp = (index) => {
    setbxpData(formData?.bxp[0]);
    openModal();
  };
  useEffect(() => {
    if (modalOpen) {
      document.body.classList.add('modal-open');
    } else {
      document.body.classList.remove('modal-open');
    }
    return () => {
      document.body.classList.remove('modal-open');
    };
  }, [modalOpen]);
  return (
    <div>

      <div className="add-education-modal add-bxp-modal add-overlay-modal-width" style={modalStyle}>
        <div className={`modal-overlay-sec   ${modalOpen ? 'active' : ''}`}></div>
        <div className="modal-width">
          <div className="modal-head">
            <h3>Add BXP</h3>
            <button onClick={closeModal} className="btn close-modal-btn">
              <img
                src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/close-icon.svg`}
                alt="Close"
              />
            </button>
          </div>

          <div className="tab-bxp">
            <Nav tabs>
              <NavItem>
                <NavLink
                  className={activeTab == "BXPDetails" ? "active" : ""}
                  onClick={() => toggleTab("BXPDetails")}
                >
                  <span>1</span> BXP Details
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={activeTab == "WorkSamples" ? "active" : ""}
                  onClick={() => toggleTab("WorkSamples")}
                >
                  <span>2</span> Work Samples
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={activeTab == "PricingTerms" ? "active" : ""}
                  onClick={() => toggleTab("PricingTerms")}
                >
                  <span>3</span> Pricing & Terms
                </NavLink>
              </NavItem>
            </Nav>
            <TabContent activeTab={activeTab}>
              <TabPane tabId="BXPDetails">
                <BXPDetails
                  bxpData={bxpData}
                  setbxpData={setbxpData}
                  setActiveTab={setActiveTab}
                />
              </TabPane>
              <TabPane tabId="WorkSamples">
                <WorkSamples
                  bxpData={bxpData}
                  setbxpData={setbxpData}
                  setActiveTab={setActiveTab}
                />
              </TabPane>
              <TabPane tabId="PricingTerms">
                <PricingTerms
                  bxpData={bxpData}
                  setbxpData={setbxpData}
                  setActiveTab={setActiveTab}
                  setFormData={setFormData}
                  setModalOpen={setModalOpen}
                />
              </TabPane>
            </TabContent>
          </div>
        </div>
      </div>

      <div className="row about-row">
        <div className="col-md-5 about-left">
          <h6>
            08/10 <span>Add BXP</span>
          </h6>
          <h2>Add your packaged based service</h2>
          <p>Specify the details of your packaged-based service to ensure clear offerings and a tailored customer experience</p>
        </div>
        <div className="col-lg-6   about-right">
          <div className="add-skip">
            <h6>Add BXP</h6>
            <button className="cart-btn" onClick={nextPage}>
              Skip for now
            </button>
          </div>
          {Array.isArray(bxpDataList) &&
            bxpDataList.map((item, index) => (
              <div className="add-education-wrapper" key={index}>
                <div className="add-first">
                  <div className="">
                    <img src={item.cover} alt="Cover" />
                  </div>
                  <div>
                    <h2>
                      {decodeHtml(item.title)} -
                      {
                        options.find(
                          (option) => option.value === item.category_id,
                        )?.label
                      }
                    </h2>
                    <CustomReactQuillDescription value={item?.description} />
                    <p>
                      {item.duration}
                      {item.duration_type == "1" ? "hour" : "day"}
                    </p>
                    <p>Price: {formatNumberWithCommas(item.price)}</p>
                  </div>
                </div>
                <div className="add-button-education">
                  <button onClick={() => deleteBxp(index)}>
                    <img
                      src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/delete-icon.svg`}
                      alt="Delete"
                    />
                  </button>
                  <button onClick={() => updateBxp(index)}>
                    <img
                      src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/edit-icon.svg`}
                      alt="Edit"
                    />
                  </button>
                </div>
              </div>
            ))}

          <button className="add-education-btn add-bxp-btn" onClick={openModal}>
            <img
              src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/plus.svg`}
              alt="Add"
            />
            Add BXP
          </button>
        </div>
      </div>

      <div className="button-container">
        <button type="button" onClick={previousPage} className="prev-button">
          <img
            src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/back-arrow.svg`}
            alt="Back"
          />
          Back
        </button>
        <button type="button" onClick={nextPage} className="next-button">
          Next
          <img
            src={`${CloudStorage.cloudurl}/Assets/Images/common/right-arrow.svg`}
            alt="Next"
          />
        </button>
      </div>
    </div>
  );
};

export default AddBXP;
